import styled, { css } from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`;

export const Col = styled.div`
  ${({ md6 }) =>
    md6 &&
    css`
      flex: 0 0 auto;
      width: 50%;
    `}
`;
